import { Box } from '@factorialco/deprecated-design-system'
import { F0Card, IconType } from '@factorialco/f0-react'
import { Bank, Building, Laptop, Present, Receipt, Wallet } from '@factorialco/f0-react/icons/app'
import {
  BankingValueObjectsOnboardingCreationSourceValueEnum,
  LegalEntityForSelectFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'
import { getDefaultAlias } from 'modules/banking/utils'

interface Props {
  creationSource: BankingValueObjectsOnboardingCreationSourceValueEnum
  legalEntity: LegalEntityForSelectFragment | null
}

const creationSourceIconMap: Record<
  BankingValueObjectsOnboardingCreationSourceValueEnum,
  IconType
> = {
  expenses: Receipt,
  expensescombined: Receipt,
  software: Laptop,
  payments: Wallet,
  benefits: Present,
  finance: Bank,
  accounts_payable: Bank,
  salary_advance: Wallet,
}

export const ExternalOnboardingExplanationStepF0 = ({ creationSource, legalEntity }: Props) => {
  const purposeLabel = getDefaultAlias(creationSource)
  const purposeIcon = creationSourceIconMap[creationSource]

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.new_wizard.step_3_1.side_title')}
      subtitle={i18n.t('banking.accounts.new_wizard.external_onboarding.redirect_description')}
    >
      <Box width="full" flexDirection="column" gap="s16" style={{ maxWidth: '500px' }}>
        <F0Card
          title={legalEntity?.legalName || '-'}
          description={i18n.t('banking.accounts.new_wizard.step_1.title')}
          avatar={{ type: 'icon', icon: Building }}
          compact
        />
        <F0Card title={purposeLabel ?? ''} avatar={{ type: 'icon', icon: purposeIcon }} compact />
      </Box>
    </WizardStepLayout>
  )
}
